import Head from 'next/head'
import { MainLayout } from 'src/layouts'
import { EventsList } from './components/EventsList'
import { WEBSITE } from 'src/consts'
import { intl } from 'src/i18n'
import { useEvents } from 'src/state'

export const Events = () => {
  const events = useEvents().data
  const eventsGroupByMonth = events.reduce((acc, item) => {
    const date = new Date(item.start_date)
    const dateKey = `${date.getUTCFullYear()}/${date.getUTCMonth() + 1}`

    if (!acc[dateKey]) acc[dateKey] = []
    acc[dateKey].push(item)

    return acc
  }, {})

  const renderHead = () => {
    const eventId = ''
    const title = intl.t('events.seo.title')
    const description = intl.t('events.seo.description')
    const url = `${WEBSITE}/events`

    return (
      <Head>
        <title>{title}</title>
        <meta id='OpenGraph-Title' property='og:title' content={title} />
        <meta id='OpenGraph-URL' property='og:url' content={url} />
        <meta property='og:image:type' content='image/png' />
        <meta property='og:image:width' content='600' />
        <meta property='og:image:height' content='315' />
        <meta
          id='OpenGraph-Image'
          property='og:image'
          content={`${WEBSITE}/assets/share/events.png`}
        />
        <meta
          id='Main-Image'
          name='image'
          content={`${WEBSITE}/assets/share/events.png`}
        />
        <meta
          id='OpenGraph-SiteName'
          property='og:site_name'
          content='COIN360'
        />
        <meta
          id='OpenGraph-Description'
          property='og:description'
          content={description}
        />
        <meta id='OpenGraph-Type' property='og:type' content='website' />
        <meta
          id='Twitter-card'
          name='twitter:card'
          content='summary_large_image'
        />
        <meta name='twitter:site' content='@coin360com' />
        <meta id='Twitter-Title' name='twitter:title' content={title} />
        <meta
          id='Twitter-Description'
          name='twitter:description'
          content={description}
        />
        <meta
          id='Twitter-Image'
          name='twitter:image'
          content={`${WEBSITE}/assets/share/events.png`}
        />
        {!eventId && (
          <script type='application/ld+json' id='Main-Script'>
            {`{
                  "@context": "http://schema.org/",
                  "@type": "WebPage",
                  "name": "${title}",
                  "description":  "${description}",
                  "url": "${url}",
                  "image": "${WEBSITE}/assets/share/events.png",
                  "sameAs": [ "https://twitter.com/coin360com" ]
                }
                `}
          </script>
        )}
        <link rel='canonical' href={url} />
      </Head>
    )
  }

  return (
    <MainLayout
      fixedHeader={true}
      title={intl.t('events.seo.title')}
      description={intl.t('events.seo.description')}
    >
      {renderHead()}
      <EventsList eventsGroupByMonth={eventsGroupByMonth} />
    </MainLayout>
  )
}

export default Events
